mutation AddUserScopes($id: ID!, $scopes: [InputUserScope]!) {
    addUserScopes(id: $id, scopes: $scopes) {
        id
        role {
            _id
        }
        scope(getScopeEntity: true) {
            client
            campaign
            campaignOnlyClient
        }
    }
}
